var _defs, _path, _path2, _path3, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardholderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentcolor;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H23C24.1046 19 25 18.1046 25 17V3C25 1.89543 24.1046 1 23 1Z",
    className: "cls-1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9H8.1012C8.3316 9 8.5549 9.0796 8.7333 9.2254C8.9117 9.3711 9.0342 9.5741 9.08 9.7999C9.2646 10.7033 9.7555 11.5153 10.4698 12.0984C11.1841 12.6815 12.0779 13 13 13C13.9221 13 14.8159 12.6815 15.5302 12.0984C16.2445 11.5153 16.7354 10.7033 16.92 9.7999C16.9658 9.5741 17.0883 9.3711 17.2667 9.2254C17.4451 9.0796 17.6684 9 17.8988 9H25",
    className: "cls-1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5H25",
    className: "cls-1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardholderIcon);
export default __webpack_public_path__ + "static/media/cardholder-icon.3fea6e32651bab869f6c0a6bb7fca164.svg";
export { ForwardRef as ReactComponent };